import './../../external/@lit/reactive-element/reactive-element.js';
import { html as y } from './../../external/lit-html/lit-html.js';
import { LitElement as s } from './../../external/lit-element/lit-element.js';
import HeaderCss from "./HeaderCss.js";
import logo from "../../assets/logo.js";
class Header extends s {
  static get styles() {
    return [HeaderCss];
  }
  static get properties() {
    return {
      text: { type: String },
      subtext: { type: String }
    };
  }
  render() {
    return y`
      <header>
        <div class="left-header">
          <div class="image">
            <img src="${logo}" @click="${() => navigate({ to: "" })}"/>
          </div>
          <div class="text">
            ${this.text}<br>
            ${this.subtext}
          </div>
        </div>
        <slot></slot>
      </header>
    `;
  }
}
customElements.define("isceco-header", Header);
export { Header };
